var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.8438,
    cy: 24.1663,
    r: 24,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.668 35.2011V13.1315H25.5993C27.0075 13.1315 28.2791 13.4363 29.4141 14.0458C30.5702 14.6553 31.474 15.496 32.1255 16.5681C32.7772 17.6189 33.103 18.817 33.103 20.1622C33.103 21.5494 32.7772 22.8 32.1255 23.914C31.474 25.007 30.5807 25.8688 29.4457 26.4993C28.3107 27.1299 27.0285 27.4452 25.5993 27.4452H20.7755V35.2011H15.668ZM27.9009 35.2011L22.2888 25.2382L27.7747 24.45L34.0173 35.2011H27.9009ZM20.7755 23.3465H25.1264C25.6728 23.3465 26.1458 23.2309 26.5451 22.9997C26.9655 22.7475 27.2807 22.4007 27.4909 21.9593C27.7222 21.5179 27.8378 21.0135 27.8378 20.446C27.8378 19.8784 27.7116 19.3845 27.4594 18.9641C27.2072 18.5228 26.8394 18.1865 26.356 17.9552C25.8936 17.7241 25.326 17.6085 24.6534 17.6085H20.7755V23.3465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendIcon);
export default __webpack_public_path__ + "static/media/resend-icon.250b182e5c07f9c30d2e64ee6c1be0fd.svg";
export { ForwardRef as ReactComponent };